import { Injectable } from '@angular/core';
import { Address } from 'src/app/domains/companies/models';

Address
@Injectable()
export class AddressService {
  constructor() {}

  // address helper functions
  private getBuildingNumber(gMapsAddress: google.maps.GeocoderAddressComponent[]) {
    return gMapsAddress.find(
      el => el.types.includes('street_number')
    ).short_name;
  }

  private getStreet(gMapsAddress: google.maps.GeocoderAddressComponent[]) {
    return gMapsAddress.find(
      el => el.types.includes('route')
    ).short_name;
  }

  public getProvince(gMapsAddress: google.maps.GeocoderAddressComponent[]): string {
    return gMapsAddress.find(
      el => el.types.includes('administrative_area_level_1')
    ).short_name;
  }

  public getCity(gMapsAddress: google.maps.GeocoderAddressComponent[]): string {
    return gMapsAddress.find(
      el => el.types.includes('locality') || el.types.includes('postal_town') || el.types.includes('administrative_area_level_3')
    ).short_name;
  }

  public getCountry(gMapsAddress: google.maps.GeocoderAddressComponent[]): string {
    return gMapsAddress.find(
      el => el.types.includes('country')
    ).short_name;
  }

  public getZip(gMapsAddress: google.maps.GeocoderAddressComponent[]): string {
    return gMapsAddress.find((el) => el.types.includes('postal_code'))
      .short_name;
  }

  public getAddressLine(gMapsAddress: google.maps.GeocoderAddressComponent[]) {
    const street = this.getStreet(gMapsAddress);
    const streetNumber = this.getBuildingNumber(gMapsAddress);
    return `${street} ${streetNumber}`;
  }

  // formatted data
  public getFormattedAddress(gMapsAddress: google.maps.GeocoderAddressComponent[]):string {
    return gMapsAddress.find((el) => el.types.includes('formatted_address'))
      .long_name;
  }

  // structured data
  public getStructuredData(gMapsAddress: google.maps.GeocoderAddressComponent[]): Address {
    return new Address(
      null,
      this.getCity(gMapsAddress),
      this.getCountry(gMapsAddress),
      this.getStreet(gMapsAddress),
      this.getBuildingNumber(gMapsAddress),
      this.getZip(gMapsAddress)
    );
  }
}
